<template>
    <div
        v-for="option in $enumOptions(group)"
        :key="`${group}-key-${option[0]}`"
    >
        <input
            :id="`${option[0]}-${group}`"
            type="radio"
            :value="option[0]"
            :checked="modelValue === option[0]"
            @click="$emit('update:modelValue', option[0])"
        />
        <label :for="`${option[0]}-${group}`">
            {{ option[1] }}
        </label>
    </div>
</template>
<script>
export default {
    props: {
        group: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            default: "",
        },
    },
    emits: ["update:modelValue"],
};
</script>
